import React from 'react';
import SubNavigation from '../sub-navigation';
import { TabItem } from '../sub-navigation/types';

const TRIP_MATCHES_TABS: TabItem[] = [
  {
    label: 'All Trips',
    to: '',
  },
  {
    label: 'Sold Trips',
    to: 'sold',
  },
];

const TripsSubNavigationContainer = () => (
  <SubNavigation
    profile={{
      primary: 'Trip Matches',
      primaryTypographyProps: {
        variant: 'h3',
      },
    }}
    tabs={TRIP_MATCHES_TABS}
  />
);
export default TripsSubNavigationContainer;
